/**
 * @typedef {Object} DrivingLicenceTypes
 * @property {number} FULL_NEW_UK - Full New UK Driving Licence, value 1
 * @property {number} FULL_UK - Full UK Driving Licence, value 2
 * @property {number} INTERNATIONAL - International Licence, value 4
 * @property {number} NO_LICENCE - No Licence, value 5
 * @property {number} PROVISIONAL_UK - Provisional UK Driving Licence, value 6
 * @property {number} EU - EU Licence, value 7
 */

/**
 * @type {DrivingLicenceTypes}
 */
const DRIVING_LICENCE_ENUM = {
    FULL_NEW_UK: 1,
    FULL_UK: 2,
    INTERNATIONAL: 4,
    NO_LICENCE: 5,
    PROVISIONAL_UK: 6,
    EU: 7,
};

module.exports = {
    DRIVING_LICENCE_ENUM
};